import { message } from "antd";
import { auth } from "./firebase";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();

export async function handleTitleRequest(transcriptionText) {
    const user = auth.currentUser;
    if (!user) {
        throw new Error("User not authenticated");
    }

    // Call the Firebase function
    const generateTitle = httpsCallable(functions, 'generateTitle');
    try {
        const result = await generateTitle({ transcription: transcriptionText });
        console.log("genTitle result :", result)
        console.log("genTitle result.data.title :", result.data.title)
        return result.data.title;
    } catch (error) {
        console.error("Error calling function:", error);
        throw error;
    }
}
